import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://www.gfmstudio.com';
export const SITE_NAME = 'GFM Studio';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/hero-background.jpg`;

/**
 * Per-route SEO tags: title, description, canonical, Open Graph, Twitter card.
 * `path` must be the route's absolute pathname (e.g. `/services/streaming`).
 */
const SEOHead = ({
  title,
  description,
  path = '/',
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  noindex = false,
  jsonLd = null,
}) => {
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEOHead;
